<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 水司查询 -->
          <a-col :md="4" :sm="12">
            <a-form-item label="水表名称">
              <a-input allow-clear v-model="query.flowMeterName" placeholder="请输入水表名称" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="仪表编码">
              <a-input allow-clear v-model="query.flowMeterNo" placeholder="请输入仪表编码" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="厂商名称">
              <a-select placeholder="请选择厂商名称" v-model="query.factory" allow-clear>
                <a-select-option v-for="item in manuList" :value="item" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="采集开始-结束时间">
              <a-range-picker v-model="collectionTime" :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['采集开始时间', '采集结束时间']" @change="collectionOnChange" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="推送开始-结束时间">
              <a-range-picker :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['推送开始时间', '推送结束时间']" @change="pushOnChange" v-model="pushTime" />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandle" :loading="exportLoading">导出</a-button>
              <!-- <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button> -->
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="danger" :disabled="isuubtn" @click="(addOrUpdateVisible = true)" style="margin-left: 8px"
                v-show="uu == '6e18d787-ce04-469f-beab-8c47e13a6361_hngy_admin'">刷新润峰</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <span slot="appearanceName" slot-scope="text,record">
        {{ record.appearanceName || record.flowMeterName }}
      </span>
    </a-table>
    <a-modal title="润峰数据手动同步" :width="800" :wrapStyle="{ top: '110px' }" v-model="addOrUpdateVisible"
      :confirmLoading="confirmLoading" @ok="OneOk" @cancel="addOrUpdateVisible = false">
      <a-form :form="formState" :label-col="{ span: 5 }" :wrapper-col="{ span: 8 }">
        <a-form-item label="开始时间">
          <a-input v-decorator="['stime', { rules: [{ required: true, message: '请填写开始时间!' }] }]" /> <span> 例如：
            2022-12-12
            00:00:00</span>
        </a-form-item>
        <a-form-item label="结束时间">
          <a-input v-decorator="['etime', { rules: [{ required: true, message: '请填写结束时间!' }] }]" /><span> 例如： 2022-12-12
            23:59:59</span>
        </a-form-item>
      </a-form>
      <p style="color: red;">提示建议：开始时间与结束时间间隔尽量2天以内，避免同步数据量过大，导致系统挂起！</p>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
import moment from 'moment'

const columns = [
  {
    title: '水表名称',
    dataIndex: 'appearanceName',
    scopedSlots: { customRender: 'appearanceName' }

  },
  {
    title: '水表厂商',
    dataIndex: 'factory'
  },
  {
    title: '水表口径',
    dataIndex: 'diameter'
  },
  {
    title: '安装地址',
    dataIndex: 'address'
  },
  {
    title: '仪表编码',
    dataIndex: 'flowMeterNo'
  },
  {
    title: '瞬时流量',
    dataIndex: 'flowRate'
  },
  {
    title: '正向累积值',
    dataIndex: 'forwardFlow'
  },
  {
    title: '反向累积值',
    dataIndex: 'reverseFlow'
  },
  // { title: '站点名称', dataIndex: 'name' },
  { title: '压力值', dataIndex: 'pressure' },

  {
    title: '采集时间',
    dataIndex: 'collectTime',
    scopedSlots: { customRender: '  collectTime' }
  },
  {
    title: '推送时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }
  // {
  //   title: '操作',
  //   width: '150px',
  //   dataIndex: 'action',
  //   scopedSlots: { customRender: 'action' }
  // }
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'WaterMeterHistory',
  data() {
    return {
      collectionTime: [],
      pushTime: [],
      manuList: [],

      queryUrl: 'pipe-network/meter-history/pages',
      queryOneUrl: 'pipe-network/meter-history',
      deleteUrl: 'pipe-network/meter-history',
      query: {
        flowMeterName: '',
        flowMeterNo: '',
        factory: '',
        collectBeginTime: '',
        collectEndTime: '',
        // tenantId: this.$store.state.user.info.tenantId,     //水司查询
        startTime: '',
        endTime: ''
      },
      addForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      uu: localStorage.getItem('tenant-user'),
      addOrUpdateVisible: false,
      isuubtn: false,
      formState: this.$form.createForm(this),
      confirmLoading: false,
      exportLoading: false
    }
  },
  created() {
    this.getManufacturer()
    this.resetList()
    // this.getAllTenant()   //水司查询
  },
  methods: {
    // 重置
    resetList() {
      this.pushTime = []
      this.collectionTime = []
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.queryList()
      // console.log(this.pushTime)
    },
    // 获取获取水司厂商选项
    getManufacturer() {
      this.$http.get('pipe-network/meter-history/factory/option').then((res) => {
        if (res.code == 0) {
          this.manuList = res.data
        }
        //  if (this.needPage) {
        //   this.list = data.list || []
        //   this.pagination.total = data.total ? parseInt(data.total) : 0
        //   console.log(this.list)
        // }
      })
    },
    pushOnChange(value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    collectionOnChange(value, dateString) {
      this.query.collectBeginTime = dateString[0]
      this.query.collectEndTime = dateString[1]
    },
    // 导出
    exportHandle() {
      // 检查采集时间是否跨月
      if (this.query.collectBeginTime && this.query.collectEndTime) {
        const beginDate = moment(this.query.collectBeginTime)
        const endDate = moment(this.query.collectEndTime)
        const beginMonth = beginDate.month()
        const beginYear = beginDate.year()
        const endMonth = endDate.month()
        const endYear = endDate.year()
        
        // 如果开始时间和结束时间不在同一年同一月，提示用户
        if (beginYear !== endYear || beginMonth !== endMonth) {
          this.$message.warning('采集开始时间和结束时间不能跨月选择，请选择同一个月内的日期范围')
          return
        }
      }
      
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = { 
        ...this.query,
        // page: this.pagination.current,
        // limit: this.pagination.pageSize
      }
      
      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'pipe-network/meter-history/export',
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '分区计量仪表历史数据.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('导出成功')
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    OneOk() {
      // 触发表单验证
      this.formState.validateFields((err, val) => {
        if (!err) {
          this.confirmLoading = true
          this.$http.get(`/api/tasks/gy/task/${val.stime}/${val.etime}`).then((res) => {
            this.$message.success(`润峰数据同步操作成功`)
            this.queryList()
            this.addOrUpdateVisible = false
            this.confirmLoading = false
          })
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
